import Eyebrow from '@/components/base/Eyebrow';

const principles = [
  { title: 'Human Understanding', copy: 'We take time to understand people as individuals — their motivations, strengths and the conditions they need to do great work.' },
  { title: 'Thoughtful Expertise', copy: 'Experience matters most when it is applied with care. Our advice is considered, practical and honest, even when that is harder.' },
  { title: 'Genuine Partnership', copy: 'We work alongside you rather than at a distance, sharing responsibility for outcomes and staying close long after decisions are made.' },
];

export default function StoryAndPhilosophy() {
  return (
    <>
      <section className="bg-white pt-12 md:pt-20 pb-16 md:pb-24">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px]">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 border-b border-foreground-950/15 pb-12 md:pb-16">
              <div className="lg:col-span-7">
                <Eyebrow>OUR STORY</Eyebrow>
                <h1 className="mt-6 md:mt-8 max-w-[680px] font-display font-normal text-[clamp(2.25rem,4.4vw,3.75rem)] leading-[1.08] tracking-[-0.015em] text-foreground-950">
                  People are at the heart of everything we do.
                </h1>
              </div>
              <div className="lg:col-span-5 lg:pt-14 space-y-4 text-[16px] md:text-[17px] leading-[1.65] text-foreground-800 max-w-[520px]">
                <p>
                  Morrow People was built around a simple belief: better understanding creates better opportunities for people and organisations alike.
                </p>
                <p className="text-foreground-700">
                  We are a small, independent team of search specialists, HR advisors and coaches. We stay deliberately close to the organisations we support, so our advice reflects how things really work.
                </p>
              </div>
            </div>
            <div className="mt-10 md:mt-14 cut-tl w-full h-[260px] sm:h-[380px] lg:h-[520px] bg-background-100 overflow-hidden" style={{ ['--cut' as string]: '72px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/sandbox/b18faa9c7b59b1c44099a46a9e2ddb65/055bae28-401f-463d-90a3-c59cb3d54fb6_about-story.webp"
                alt="Morrow People colleagues in conversation"
                title="Morrow People team — our story"
                data-reveal-image
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-20 md:py-28">
        <div className="wrap">
          <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
            <div data-reveal className="lg:col-span-4">
              <Eyebrow>WHAT WE BELIEVE</Eyebrow>
            </div>
            <div data-reveal className="lg:col-span-8">
              <h2 className="max-w-[760px] font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] text-foreground-950">
                Good advice begins with listening. <span className="text-foreground-500">Lasting progress begins with trust.</span>
              </h2>
            </div>
          </div>
          <div data-reveal-stagger className="mx-auto max-w-[1280px] mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-10">
            {principles.map((p, i) => (
              <div key={p.title} className="border-t border-foreground-950/20 pt-5">
                <span className="block font-label text-[13px] leading-none tracking-[0.12em] text-accent-600">0{i + 1}</span>
                <h3 className="mt-8 font-heading text-[24px] leading-tight text-foreground-950">{p.title}</h3>
                <p className="mt-3 text-[15px] leading-[1.65] text-foreground-700 max-w-[360px]">{p.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}